<div class="flex flex-column gap-2">
    <p-dropdown [options]="emplacementOptions" [(ngModel)]="selectedAdresse" [filter]="true" filterBy="label,title"
        [showClear]="false" placeholder="Sélectionner une adresse" styleClass="w-full" [group]="true"
        [loading]="!emplacementOptions" virtualScroll [virtualScrollItemSize]="38" (onChange)="change($event.value)">
        <ng-template let-group pTemplate="group">
        </ng-template>
        <ng-template let-item pTemplate="item">
            <div class="flex justify-content-between align-items-center gap-2">
                <div class="flex align-items-center flex-grow-1">
                    <i *ngIf="item.type == 'principal'" class="pi pi-map-marker mr-1 text-primary"
                        style="font-size: 1.5rem;"></i>
                    <i *ngIf="item.type == 'adresse'" class="mx-1 text-500">└─</i>
                    <span *ngIf="item.type == 'principal'" class="font-semibold">{{ item.label }}</span>
                    <span *ngIf="item.type == 'adresse'" class="text-sm">{{ item.label }}</span>
                </div>
                <p-button *ngIf="item.type == 'principal'" icon="pi pi-plus" (click)="ouvrirDialogueAjouterAdresse(item.emplacementId); $event.stopPropagation()" size="small" text pTooltip="Ajouter un emplacement secondaire" tooltipPosition="top"></p-button>
            </div>
        </ng-template>
    </p-dropdown>
</div>